const t = {
  name: "TriangleRight",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.1008 12.5001L8.5 6.41943V18.5807L16.1008 12.5001Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as TriangleRight
};
